import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import './Nav.css';

class Nav extends Component {
	render() {
		return (
			<ul className="nav">
				<NavLink to={'/'} exact>
					<div>
						<li>Home </li>
						<FontAwesome name="chevron-right" className="icon" />
					</div>
				</NavLink>
				<NavLink to={'/players'}>
					<div>
						<li>Players </li>
						<FontAwesome name="chevron-right" className="icon" />
					</div>
				</NavLink>
				<NavLink to={'/matches'}>
					<div>
						<li>Matches </li>
						<FontAwesome name="chevron-right" className="icon" />
					</div>
				</NavLink>
				<NavLink to={'/login_out'} exact>
					<div>
						<li>Login out </li>
						<FontAwesome name="chevron-right" className="icon" />
					</div>
				</NavLink>
			</ul>
		);
	}
}

export { Nav };



// WEBPACK FOOTER //
// ./src/components/common/nav/Nav.js